import React from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import ErrorBlock from 'components/ErrorBlock';

import {roomInspectionRemove} from 'ducks/frontDesk';

import './styles.css';

const onSubmit = (_values, dispatch, props) => {
  const {locationRef, bookingId, allocationId, getExtraActions} = props;

  dispatch(
    roomInspectionRemove(
      {locationRef, bookingId, allocationId},
      getExtraActions()
    )
  );
};

const RoomInspectionRemoveForm = ({error}) => (
  <form className="RoomInspectionRemoveForm">
    {error && <ErrorBlock>{error}</ErrorBlock>}
    <div className="confirmationQuestion">
      Are you sure you want to remove the inspection for this room?
    </div>
  </form>
);

const roomInspectionRemoveForm = reduxForm({
  form: 'roomInspectionRemove',
  onSubmit: onSubmit
})(RoomInspectionRemoveForm);

export default connect()(roomInspectionRemoveForm);
